import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import Background from '../../../../components/Editor/Page/Background';
import {
	isEditablePage,
	getGeneralBgData,
	getPageBgData,
} from '../../selectors';
import { getResourceUrl, getVideoCover } from '../../utils/helpers';
import { Api } from '../../../../typings/api';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			isPageBackgroundActive,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
		galleryInfos,
		routerParamsHistory,
	} = state;

	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];

	const backgroundData = getPageBgData(state) || getGeneralBgData(state);
	let url = '';
	let mediaType = Api.AssetItemFileTypes.IMAGE;
	let color: string | undefined;

	if (backgroundData) {
		if (backgroundData.defaultColor) {
			color = backgroundData.defaultColor;
		} else {
			const { currentMedia: { relUrl, type } } = backgroundData;
			url = getResourceUrl(relUrl, galleryInfos.config, +resourceId);
			mediaType = type;

			if (type === Api.AssetItemFileTypes.MOVIE) {
				url = getVideoCover(url);
			}
		}
	}

	return {
		url,
		color,
		isEditable: isEditablePage(state),
		isActive: isPageBackgroundActive,
		isEditPanelDisplayed,
		mediaType,
	};
};

export default connect(mapStateToProps)(Background);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Page/Background/index.tsx